import { render, staticRenderFns } from "./toSafesTransfers.vue?vue&type=template&id=46be8a22"
import script from "./toSafesTransfers.vue?vue&type=script&lang=js"
export * from "./toSafesTransfers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports